import React, { forwardRef } from "react";
import MT from "material-table";
import { CsvBuilder } from "filefy";
import jsPDF from "jspdf";
import "jspdf-autotable";
import AddBox from "@material-ui/icons/AddBox";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import Check from "@material-ui/icons/Check";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Clear from "@material-ui/icons/Clear";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import Edit from "@material-ui/icons/Edit";
import FilterList from "@material-ui/icons/FilterList";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import Remove from "@material-ui/icons/Remove";
import SaveAlt from "@material-ui/icons/SaveAlt";
import Search from "@material-ui/icons/Search";
import ViewColumn from "@material-ui/icons/ViewColumn";

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};

const MaterialTable = (props) => {
  const exportPdf = (columns, data) => {
    const doc = new jsPDF();
    doc.autoTable({
      head: [columns.map((col) => col.title)],
      body: data.map((row) =>
        columns.map((col) =>
          typeof row[col.field] === "object" ? "" : row[col.field]
        )
      ),
    });
    doc.save("table.pdf");
  };

  const exportCsv = (columns, data) => {
    const columnTitles = columns.map((col) => col.title);
    console.log("exportCsv data",data)
    const csvData = data.map((row) =>
      columns.map((col) =>
        typeof row[col.field] === "object" ? "" : row[col.field]
      )
    );

    new CsvBuilder("table.csv")
      .setColumns(columnTitles)
      .addRows(csvData)
      .exportFile();
  };

  return (
    <MT
      {...props}
      icons={tableIcons}
      options={{
        pageSize: 10,
        sorting: true,
        search: true,
        pageSizeOptions: [5, 10, 25, 50],
        exportButton: {
          csv: true,
          pdf: true,
        },
        exportCsv,
        exportPdf,
        grouping: true,
        headerStyle: {
          paddingLeft: 20,
          paddingRight: 20,
          borderBottom: "1px solid light-grey",
        },
        rowStyle: {
          paddingLeft: 20,
          height: "15px",
          fontSize: "normal",
        },
      }}
    />
  );
};

export default MaterialTable;
